{
  "zh-CN": {
    "models": {
      "image": {
        "background": "用作背景?",
        "enabled": "已启用?",
        "global": "全局?",
        "delete": "删除",
        "start": "开始",
        "cancel": "取消",
        "processing": "处理中...",
        "error": "错误",
        "name": "名称",
        "size": "文件大小",
        "dropzone": "将图片拖放到此处"
      }
    }
  }
}
